// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b07c8a37","952":"ae5e6f81"}[chunkId] + ".chunk.js";
};